import { type Common } from '../common.js';
import { type FilterOptions, type LabelingJob } from '../models/predict/labeling.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getJobQueue(options: FilterOptions): Promise<LabelingJob[] | undefined> {
    const url = this.common.constructPath(`/predict/documents/labeling-jobs`, options);
    const response = this.common.getJSON(url);
    return await response;
  }

  async claimJob(jobId: string) {
    const url = this.common.constructPath(`predict/documents/labeling-jobs/${jobId}`);
    const response = this.common.patchJSON(url);
    return await response;
  }

  async cancelJob(jobId: string) {
    const url = this.common.constructPath(`predict/documents/labeling-jobs/${jobId}`);
    const response = this.common.deleteJSON(url);
    return await response;
  }

  async disclaimJob(jobId: string) {
    const url = this.common.constructPath(`predict/documents/labeling-jobs/${jobId}/user`);
    const response = this.common.deleteJSON(url);
    return await response;
  }
}
